function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".delete_active_svg__cls-1{fill:#6cff00}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "delete_active_svg__Group_21667"
}, /*#__PURE__*/React.createElement("g", {
  id: "delete_active_svg__Group_21658"
}, /*#__PURE__*/React.createElement("path", {
  id: "delete_active_svg__Path",
  d: "M0 10.667a1.824 1.824 0 001.857 1.778h7.429a1.824 1.824 0 001.857-1.778V0H0z",
  className: "delete_active_svg__cls-1",
  transform: "translate(.929 3.556)"
}), /*#__PURE__*/React.createElement("path", {
  id: "delete_active_svg__Path-2",
  d: "M13 .889H9.75L8.821 0H4.179L3.25.889H0v1.778h13z",
  className: "delete_active_svg__cls-1"
})));
function SvgDeleteActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "delete_active_svg__Component_124_3",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_124_3' width='13' height='16' viewBox='0 0 13 16'%3e %3cdefs%3e %3cstyle%3e .cls-1%7bfill:%236cff00%7d %3c/style%3e %3c/defs%3e %3cg id='Group_21667'%3e %3cg id='Group_21658'%3e %3cpath id='Path' d='M0 10.667a1.824 1.824 0 0 0 1.857 1.778h7.429a1.824 1.824 0 0 0 1.857-1.778V0H0z' class='cls-1' transform='translate(.929 3.556)'/%3e %3cpath id='Path-2' d='M13 .889H9.75L8.821 0H4.179L3.25.889H0v1.778h13z' class='cls-1'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgDeleteActive as ReactComponent };